/* js/auth-cards.js — the explanation deck on the auth screen (partials/auth-art.php).
   The stripes, the arrow keys and a horizontal swipe on the dark panel move through the cards; it wraps
   around at both ends. Below 900px the panel is a full-screen intro with an × that reveals the form.
   No storage, no timers: the panel never changes on its own while someone types a password next to it. */
(function () {
  'use strict';
  function init() {
    var art = document.querySelector('[data-gs-cards]');
    if (!art || art.__gsCards) return;
    art.__gsCards = 1;
    var cards = art.querySelectorAll('.gs-card-x');
    var dashes = art.querySelectorAll('.gs-dash');
    var n = cards.length;
    if (!n) return;
    var cur = 0;
    for (var k = 0; k < n; k++) if (cards[k].classList.contains('is-on')) cur = k;

    function show(i, dir) {
      i = ((i % n) + n) % n;
      if (i === cur) return;
      var from = cards[cur], to = cards[i];
      to.classList.toggle('from-left', dir < 0);
      from.classList.remove('is-on'); from.setAttribute('aria-hidden', 'true');
      dashes[cur].classList.remove('is-on'); dashes[cur].removeAttribute('aria-current');
      // next frame, so the incoming card starts from its side and slides in
      requestAnimationFrame(function () {
        to.classList.add('is-on'); to.classList.remove('from-left'); to.removeAttribute('aria-hidden');
      });
      dashes[i].classList.add('is-on'); dashes[i].setAttribute('aria-current', 'true');
      art.setAttribute('data-focus', to.getAttribute('data-focus') || 'all');
      cur = i;
    }

    /* Below 900px the panel is a full-screen intro over the form (css/auth-cards.css). The page under it
       must not scroll, and the × hands over to the form with the cursor in the email field. */
    var small = window.matchMedia ? matchMedia('(max-width: 900px)') : { matches: false };
    var root = document.documentElement;
    function syncOpen() { root.classList.toggle('gs-art-open', small.matches && !art.classList.contains('is-closed')); }
    function closeArt() {
      art.classList.add('is-closed');
      syncOpen();
      var f = document.querySelector('[data-gs="email"]') || document.querySelector('.gs-auth-main input, .gs-auth-main button');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    }
    var x = art.querySelector('.gs-art-close');
    if (x) x.addEventListener('click', closeArt);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && small.matches && !art.classList.contains('is-closed')) closeArt(); });
    if (small.addEventListener) small.addEventListener('change', syncOpen);
    syncOpen();
    if (small.matches && x && !art.classList.contains('is-closed')) { try { x.focus({ preventScroll: true }); } catch (e) {} }
    dashes.forEach(function (b) {
      b.addEventListener('click', function () { var i = +b.getAttribute('data-i'); show(i, i < cur ? -1 : 1); });
    });
    art.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { show(cur + 1, 1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { show(cur - 1, -1); e.preventDefault(); }
    });

    // Swipe: a mostly-horizontal drag of 40px+ on the panel. Mouse drags count too (trackpads, desktops).
    var sx = null, sy = 0, st = 0;
    art.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('a,input,.gs-art-close')) { sx = null; return; }
      sx = e.clientX; sy = e.clientY; st = Date.now();
    });
    art.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3 && Date.now() - st < 1200) show(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
    });
    art.addEventListener('pointercancel', function () { sx = null; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
